import { Stack } from '@mui/material';
import { AssessmentStatuses } from '@schooly/constants';
import { FC, PropsWithChildren, useCallback } from 'react';

import { DropdownSelect, DropdownSelectProps } from '../DropdownSelect';
import { renderAssessmentStatusTags } from './AssessmentStatusExpandedSelect';

type AssessmentStatusSelectMultipleProps = PropsWithChildren<{
  selectedStatuses: AssessmentStatuses[];
  onSelectStatus: (v: AssessmentStatuses) => void;
}> &
  Omit<DropdownSelectProps, 'children' | 'renderContent'>;

const OPTIONS = [AssessmentStatuses.Published, AssessmentStatuses['Not published']];

export const AssessmentStatusSelectMultiple: FC<AssessmentStatusSelectMultipleProps> = ({
  selectedStatuses,
  onSelectStatus,
  placeholder,
  ...dropdownProps
}) => {
  const renderContent = useCallback(() => {
    return (
      <Stack direction="row" flexWrap="wrap" gap={1} m={1}>
        {renderAssessmentStatusTags({
          statuses: OPTIONS,
          tagProps: (status) => ({
            variant: selectedStatuses.includes(status) ? 'filled' : undefined,
          }),
          onClick: onSelectStatus,
        })}
      </Stack>
    );
  }, [onSelectStatus, selectedStatuses]);

  return (
    <DropdownSelect
      {...dropdownProps}
      placeholder={placeholder}
      hasValues={!!selectedStatuses.length}
      renderContent={renderContent}
    >
      {(opened) => (
        <>
          {renderAssessmentStatusTags({
            statuses: selectedStatuses,
            tagProps: { size: placeholder ? 'small' : undefined },
            onDelete: opened ? onSelectStatus : undefined,
          })}
        </>
      )}
    </DropdownSelect>
  );
};
